<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-alert-triangle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M27.452 5.985a4 4 0 00-6.91 0L2.545 36.015A4 4 0 006 42.032h35.993a4 4 0 003.455-6.015L27.452 5.986zM6 38.031l17.997-30.03 17.996 30.03H6zm18.747-6c.76 0 1.375.616 1.375 1.375v1.375c0 .76-.616 1.375-1.375 1.375h-1.375c-.76 0-1.375-.615-1.375-1.375v-1.375c0-.759.616-1.375 1.375-1.375h1.375zm1.258-15.002a1 1 0 00-1-1h-2a1 1 0 00-1 1V29.03a1 1 0 001 1h2a1 1 0 001-1v-12z"/></svg>
</template>
<script>

export default {
  name: 'IconAlertTriangle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
